import { ref } from 'vue';
import { defineStore } from 'pinia';

const sideNavOpenStorageKey = 'isSideNavOpen';

export const useAppSideNav = defineStore('appSideNav', () => {
  const isSideNavOpen = ref(false);

  const updateAppSideNavInLocalStorage = (value) => {
    localStorage.setItem(sideNavOpenStorageKey, Boolean(value));
  };

  const initAppSideNavFromLocalStorage = () => {
    const storageValue = localStorage.getItem(sideNavOpenStorageKey);

    if (storageValue !== undefined || storageValue !== null) {
      isSideNavOpen.value = storageValue === 'true';
    }
  };

  return {
    isSideNavOpen,
    updateAppSideNavInLocalStorage,
    initAppSideNavFromLocalStorage,
  };
});
